<template>
  <base-slide-panel :isOpen="panelOpen" @closePanel="togglePanel">
    <template slot="header">
      <div class="h-16 bg-secondary dark:bg-darkblue-600 flex items-center justify-between text-white px-4">
        <div class="flex items-center">
          <base-icon name="filter"/>
          <h2 class="font-bold ml-2">{{ $t('app.filter_by') }}</h2>
        </div>
        <span class="cursor-pointer" @click="togglePanel">
          <base-button-icon name="cross" size="xs" iconSize="sm" mode="secondary" />
        </span>
      </div>
    </template>
    <template slot="main">
      <div class="form-wrapper p-4 dark:bg-darkblue-800 dark:text-darkblue-200">
        <el-form
          ref="ruleForm"
        >
          <div>
            <base-collapsible class="mb-3"
                customContent="bg-white dark:bg-darkblue rounded-lg border-solid border-primary-100 dark:border-darkblue-600 border p-4 mt-2">
                <template slot="headerRight">
                  <div class="flex flex-col py-2">
                    <h2 class="dark:text-darkblue-100">{{ $t('approval_workflow.creation_date_range') }}</h2>
                  </div>
                </template>
                <template slot="content">
                  <div>
                    <div>
                      <label class="text-sm font-semibold text-secondary-600 block mb-1">{{ $t('app.from') }}</label>
                      <el-form-item prop="fechaCreacionDesde">
                        <el-date-picker class="bg-white dark:bg-darkblue-900"
                          v-model="form.fechaCreacionDesde.value" type="date" :picker-options="dateRangeOptions"
                          :format="datePattern" value-format="yyyy-MM-dd[T00:00:00]" placeholder="">
                        </el-date-picker>
                      </el-form-item>
                    </div>
                    <div>
                      <label class="text-sm font-semibold text-secondary-600 block mb-1">{{ $t('app.to') }}</label>
                      <el-form-item prop="fechaCreacionHasta">
                        <el-date-picker class="bg-white dark:bg-darkblue-900"
                          v-model="form.fechaCreacionHasta.value" type="date" :picker-options="dateRangeOptions"
                          :format="datePattern" value-format="yyyy-MM-dd[T00:00:00]" placeholder="">
                        </el-date-picker>
                      </el-form-item>
                    </div>
                  </div>
                </template>
              </base-collapsible>
          </div>

          <div class="lg:mb-2">

            <div v-if="(role === 7 || role === 8 || role === 3)">
              <label class="text-sm font-semibold text-secondary-600 block mb-1">{{ $t('clients.entity_name') }}</label>
              <el-form-item prop="empresa">
                <base-el-select class="w-full" :options="clientes" v-model="form.empresa.value" clearable filterable
                  value-key="idCliente" :loading="loadingClientes" />
              </el-form-item>
            </div>

            <div>
              <label class="text-sm font-semibold text-secondary-600 block mb-1">{{ $t('app.name') }}</label>
              <el-form-item prop="nombreFlujo">
                <el-input
                  clearable
                  class="w-full"
                  v-model="form.nombreFlujo.value"
                  maxlength="200"
                />
              </el-form-item>
            </div>

            <div>
              <label class="text-sm font-semibold text-secondary-600 block mb-1">{{ $t('invoices.invoices_issuing.descripcion') }}</label>
              <el-form-item prop="descripcion">
                <el-input
                  clearable
                  class="w-full"
                  v-model="form.descripcion.value"
                  maxlength="200"
                />
              </el-form-item>
            </div>

            <div>
              <label class="text-sm font-semibold text-secondary-600 block mb-1">{{ $t('app.active') }}</label>
              <el-form-item prop="activo">
                <base-el-select class="w-full" :options="values" v-model="form.activo.value" clearable :placeholder="$t('companies.active_yes_no')" />
              </el-form-item>
            </div>
 
          </div>
        </el-form>
      </div>
    </template>
    <template slot="footer">
      <base-button @click="togglePanel" mode="secondary-phantom-blue" :text="$t('app.cancel')"/>
      <base-button mode="secondary-phantom-blue" class="w-full" :text="$t('app.apply')" @click="applyFilters"/>
    </template>
  </base-slide-panel>
</template>

<script>
import { i18n } from '@/i18n'
import { getClients } from '@/services/clients/getClients'
import getLocaleDateTimeFormat from '@/services/functions/getLocaleDateTimeFormat'

export default {
  /* eslint-disable camelcase */
  name: 'filter-panel',
  props: {
    panelOpen: {
      type: Boolean,
      default: false
    }
  },
  data: function () {
    return {
      dateRangeOptions: {
        firstDayOfWeek: 1,
      },
      vuexnamespace: 'workflow',
      isOpen: this.panelOpen,
      loadingDistribuidores: false,
      loadingClientes: false,
      form: {
        empresa: { label: i18n.t('clients.entity_name'), value: '' },
        nombreFlujo: { label: i18n.t('app.name'), value: '' },
        descripcion: { label: i18n.t('invoices.invoices_issuing.descripcion'), value: '' },
        activo: { label: i18n.t('app.active'), value: '' },
        fechaCreacionDesde: { label: i18n.t('approval_workflow.creation_date_from'), value: '' },
        fechaCreacionHasta: { label: i18n.t('approval_workflow.creation_date_to'), value: '' },
      },
      values: [
        {
          value: true,
          label: i18n.t('app.yes')
        },
        {
          value: false,
          label: i18n.t('app.no')
        }
      ],
      distribuidores: [],
      clientes: [],
    }
  },
  watch: {
    panelOpen: {
      handler: 'panelOpenHandler'
    }
  },
  mounted: async function () {
    if (this.role === 7 || this.role === 8 || this.role === 3) {
      this.loadingClientes = true
      const dataClients = await getClients()
      if (dataClients.blnError === true) {
        this.doFeedback(i18n.t('feedback.error.formated_api_response_error', dataClients))
      }
      this.clientes = dataClients.Clientes.map(x => ({ label: x.Nombre, key: x.idCliente, value: { idCliente: x.idCliente, Nombre: x.Nombre } }))
      this.loadingClientes = false
    }
  },
  computed: {
    role: function () {
      return this.$store.getters['auth/role']
    },
    datePattern () {
      const formatKey = 'numeric_date'
      const locale = i18n.locale || 'es'
      return getLocaleDateTimeFormat(formatKey, locale)
    },
    tiposUnidadesMedida: function () {
      return this.$store.getters['config/TIPOS_UNIDADES_MEDIDA']
    },
  },
  methods: {
    panelOpenHandler: function (data) {
      const _temp = this.$store.getters[this.vuexnamespace + '/getMasterFilters']
      if (_temp) {
        this.resetForm()
        this.form.empresa.value = _temp.empresa !== undefined && _temp.empresa.value !== '' ? _temp.empresa.value : ''
        this.form.nombreFlujo.value = _temp.nombreFlujo !== undefined && _temp.nombreFlujo.value !== '' ? _temp.nombreFlujo.value : ''
        this.form.descripcion.value = _temp.descripcion !== undefined && _temp.descripcion.value !== '' ? _temp.descripcion.value : ''
        this.form.fechaCreacionDesde.value = _temp.fechaCreacionDesde !== undefined && _temp.fechaCreacionDesde.value !== '' ? _temp.fechaCreacionDesde.value : ''
        this.form.fechaCreacionHasta.value = _temp.fechaCreacionHasta !== undefined && _temp.fechaCreacionHasta.value !== '' ? _temp.fechaCreacionHasta.value : ''
        this.form.activo.value = _temp.activo !== undefined && _temp.activo.value !== '' ? _temp.activo.value : ''
      }
    },
    togglePanel: function () {
      this.isOpen = !this.isOpen
      // this.resetForm()
      this.$emit('togglePanel')
    },
    resetForm: function () {
      this.form = {
        empresa: { label: i18n.t('clients.entity_name'), value: '' },
        nombreFlujo: { label: i18n.t('app.name'), value: '' },
        descripcion: { label: i18n.t('invoices.invoices_issuing.descripcion'), value: '' },
        activo: { label: i18n.t('app.active'), value: '' },
        fechaCreacionDesde: { label: i18n.t('approval_workflow.creation_date_from'), value: '' },
        fechaCreacionHasta: { label: i18n.t('approval_workflow.creation_date_to'), value: '' },
      }
    },
    applyFilters: function () {
      this.$store.commit(this.vuexnamespace + '/setMasterFilters', this.form)
      this.$emit('applyFilters', true)
      this.isOpen = !this.isOpen
      this.$emit('togglePanel')
    },
  }
}
</script>

<style lang="scss" scoped></style>
